// extracted by mini-css-extract-plugin
export default {"divider":"no-template-results-module__divider--fUhVZ"};